import React from "react";
import StarRatings from "react-star-ratings";
import Review from "./Review";

export default function ListReviews(props) {
  const model = props.business || props.social;
  if (props.reviews.length === 0) {
    return <b>No reviews yet</b>
  }
  return (
    <div>
      <div>
        <h5>Average Score:</h5>
        <div>
          <StarRatings
            rating={model.average_score}
            starRatedColor="gold"
            starDimension="40px"
            starSpacing="1px"
            starHoverColor="gold"
            numberOfStars={5}
            name="rating"
          />
        </div>
        <div>
          {props.reviews &&
            props.reviews.map((review) => {
              return <Review review={review} />;
            })}
        </div>
      </div>
    </div>
  );
}
